import {GenderTypes} from 'interfaces';

export const genderTypeOptions = [
  {label: 'Male', value: GenderTypes.male},
  {label: 'Female', value: GenderTypes.female},
  {label: 'Other', value: GenderTypes.other},
];
